import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path='/login' element={<h1>.</h1>} />
        <Route path='/signup' element={<h1>.</h1>} />
      </Route>
    </Routes>
  );
}

export default App;
